import type { JsonValue } from "@dutyon/apis";

export function parseTrialApplicationSurvey(surveyData: JsonValue | null): Record<string, unknown> {
  try {
    const parsed: unknown = typeof surveyData === "string" ? JSON.parse(surveyData) : surveyData;
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed as Record<string, unknown>;
    }
  } catch {
    // 이전 데이터의 JSON 형식이 잘못된 경우 빈 설문으로 안전하게 표시합니다.
  }

  return {};
}
